module.exports = __webpack_public_path__ + "img/forecast_probit_dimension.e7dd677b.png";